import React from 'react'

import './About.css'

//MUI
import { Box, Container, Grid, List, ListItem, ListItemIcon, ListItemText, Typography, useMediaQuery } from '@mui/material'
import SchoolIcon from '@mui/icons-material/School';
import AddCommentIcon from '@mui/icons-material/AddComment';
import AnalyticsIcon from '@mui/icons-material/Analytics';
import PageviewIcon from '@mui/icons-material/Pageview';
import NewReleasesIcon from '@mui/icons-material/NewReleases';

//Images
import img_5 from '../../assets/images/img_5_full.png'
import logo_typo from '../../assets/images/logo_2_nb.png'
import competencias_1 from '../../assets/images/compentecias_1.png'
import competencias_2 from '../../assets/images/compentecias_2.png'
import img_7 from '../../assets/images/img_7_nb.png'
import map from '../../assets/images/img_8_1440x782.png'
import map_nt from '../../assets/images/map_NT.png'
// import img_4_1440x782 from '../../assets/images/img_4_1440x782.png'
// import img_4_1600x900 from '../../assets/images/img_4_1600x900.png'
// import img_4_1080x920 from '../../assets/images/img_4_1080x920.png'
import nuestrosClientes from '../../assets/images/nustros-clientes_06.png';

const competencies = [
    {
        title: 'Conocimiento y experiencia',
        icon: <SchoolIcon sx={{ color: '#004A86' }} />,
    },
    {
        title: 'Atención médica y gestión de emergencias',
        icon: <AddCommentIcon sx={{ color: '#004A86' }} />,
    },
    {
        title: 'Análisis y comunicación efectiva',
        icon: <AnalyticsIcon sx={{ color: '#004A86' }} />,
    },
    {
        title: 'Monitoreo y seguimiento constante',
        icon: <PageviewIcon sx={{ color: '#004A86' }} />,
    },
    {
        title: 'Gestión integral de riesgos',
        icon: <NewReleasesIcon sx={{ color: '#004A86' }} />,
    }
]

const About = () => {

    const matchesTablet = useMediaQuery('(max-width: 991.5px)');
    const matchesMobile = useMediaQuery('(max-width: 500px)');

    return (
        <>
            <Box sx={{ mt: { xxl: 6, xl: 6, lg: 6, md: 6, sm: 6, xs: 0 }, width: '100%' }}>
                <Box sx={{ width: { xxl: '70%', xl: '70%', lg: '75%', md: '85%', sm: '100%', xs: '100%' }, ml: 'auto' }}>
                    <Grid container spacing={4} alignItems="center" sx={{ backgroundColor: '#FAFAFA' }}>
                        <Grid
                            className='about_grid_top'
                            size={{ xxl: 7, xl: 7, lg: 7, md: 7, sm: 7, xs: 12 }}
                            order={{ xxl: 1, xl: 1, lg: 1, md: 1, sm: 1, xs: 2 }}
                        >
                            <img src={logo_typo} alt="logo" className='about_fh_logo' width="300" style={{ marginBottom: '15px' }} />
                            <Typography variant="body1" sx={{ fontSize: '18px' }} color="text.secondary">
                                Es tu aliado nacional en la creación de ambientes laborales seguros y saludables. Impulsamos la sostenibilidad
                                de tu empresa y de quienes la hacen posible, adaptándonos a tus necesidades y construyendo relaciones a largo plazo.
                            </Typography>
                        </Grid>
                        <Grid
                            size={{ xxl: 5, xl: 5, lg: 5, md: 5, sm: 5, xs: 12 }}
                            order={{ xxl: 2, xl: 2, lg: 2, md: 2, sm: 2, xs: 1 }}
                            sx={{ display: 'flex' }}
                        >
                            <Box
                                className='about_img_top'
                                component="img"
                                src={img_5}
                                alt="img_5"
                                sx={{
                                    width: '100%',
                                    height: { xxl: 550, xl: 450, lg: 350, md: 300, sm: 300, xs: 300 },
                                    objectFit: 'cover',
                                }}
                            />
                        </Grid>
                    </Grid>
                </Box>
            </Box>

            <Container maxWidth='xxl' sx={{ mt: 10 }}>
                <Grid container spacing={2} alignItems='center'>
                    <Grid size={{ xxl: 6, xl: 7, lg: 7, md: 5, sm: 12, xs: 12 }} className='grid_imgs' sx={{ height: 400 }}>
                        <Box className='flex_SC2' sx={{ display: 'flex', justifyContent: 'flex-start' }}>
                            <Box>
                                <Box className='img_SC2'
                                    component='img'
                                    src={competencias_1}
                                    sx={{
                                        width: '100%',
                                        height: 400,
                                        objectFit: 'cover',
                                    }}
                                />
                            </Box>
                            <Box>
                                <Box className='img_SC2'
                                    component='img'
                                    src={competencias_2}
                                    sx={{
                                        width: '100%',
                                        height: 400,
                                        objectFit: 'cover',
                                    }}
                                />
                            </Box>
                        </Box>
                    </Grid>

                    <Grid size={{ xxl: 6, xl: 5, lg: 5, md: 7, sm: 12, xs: 12 }} sx={{ textAlign: matchesTablet ? 'left' : 'center' }}>
                        <Typography sx={{ color: '#004A86', fontWeight: '900', fontSize: matchesMobile ? '30px' : '42px', lineHeight: 1 }} gutterBottom>
                            Nuestras competencias
                        </Typography>
                        <List>
                            {competencies.map((item) => (
                                <ListItem
                                    key={item.title}
                                    disableGutters
                                    sx={{
                                        display: 'flex',
                                        justifyContent: matchesTablet ? 'left' : 'center',
                                        alignItems: matchesTablet ? 'left' : 'center',
                                    }}
                                >
                                    <Box sx={{ display: 'flex', alignItems: 'center' }}>
                                        <ListItemIcon sx={{ minWidth: 'unset', mr: 1, }}>
                                            {item.icon}
                                        </ListItemIcon>
                                        <ListItemText
                                            primary={item.title}
                                            primaryTypographyProps={{ textAlign: 'center' }}
                                            sx={{ color: '#868686', m: 0 }}
                                        />
                                    </Box>
                                </ListItem>
                            ))}
                        </List>
                    </Grid>
                </Grid>
            </Container>

            <Container maxWidth='xl' sx={{ mt: 10, mb: 5 }}>
                <Typography textAlign='center' sx={{ color: '#004A86', fontWeight: '900', fontSize: '30px' }}>NUESTRO PROPÓSITO</Typography>
                <Typography variant='h6' color='text.secondary' textAlign='center'>
                    “Impulsamos la sostenibilidad y a quienes la hacen posible”
                </Typography>
                <Box sx={{ mt: 5, textAlign: 'center' }}>
                    <img src={img_7} alt={img_7} className='prop_img' width='70%' />
                </Box>
                <Box sx={{ mt: 10 }}>
                    <div className='map_content'>
                        <img src={map} alt={map} className='map_img' />
                        <div className='map_text'>
                            <Typography variant='h4' className='map_text_styles'>
                                Cobertura y representación nacional para <span style={{ fontWeight: '900' }}>servicios médicos</span>
                            </Typography>
                        </div>
                    </div>
                    <div className='map_content_m'>
                        <Typography variant='h5' sx={{ mb: 3, color: '#004A86' }} textAlign='center'>
                            Cobertura y representación nacional para <span style={{ fontWeight: '900' }}>servicios médicos</span>
                        </Typography>
                        <img src={map_nt} alt={map_nt} width='100%' />
                    </div>
                </Box>

                <Box sx={{ mt: 10 }}>
                    <Typography sx={{ fontWeight: '900', color: '#004A86', mb: 2, fontSize: matchesMobile ? '34px' : '38px' }} textAlign='center'>
                        Nuestros clientes
                    </Typography>
                    <img
                        src={nuestrosClientes}
                        alt="clientes-factor+health"
                        // src={matchesMobile ? img_4_1080x920 : matchesTablet ? img_4_1600x900 : img_4_1440x782}
                        // alt={matchesMobile ? img_4_1080x920 : matchesTablet ? img_4_1600x900 : img_4_1440x782}
                        width='100%'
                    />
                    <Typography variant='h4' textAlign='center' sx={{ mt: 3, color: '#868686' }}>
                        La salud de su equipo, nuestra prioridad
                    </Typography>
                </Box>
            </Container>
        </>
    )
}

export default About